var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Any, JsonObject, JsonProperty } from 'json2typescript';
var GraphQLConfig = (function () {
    function GraphQLConfig(partial) {
        this.useNaturalPluralization = false;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('use_natural_pluralization'),
        __metadata("design:type", Object)
    ], GraphQLConfig.prototype, "useNaturalPluralization", void 0);
    GraphQLConfig = __decorate([
        JsonObject('GraphQLConfig'),
        __metadata("design:paramtypes", [Object])
    ], GraphQLConfig);
    return GraphQLConfig;
}());
export { GraphQLConfig };
export var GraphQLAlertType;
(function (GraphQLAlertType) {
    GraphQLAlertType["Mongo"] = "mongo";
    GraphQLAlertType["Custom"] = "custom";
})(GraphQLAlertType || (GraphQLAlertType = {}));
var GraphQLAlert = (function () {
    function GraphQLAlert(partial) {
        this.errorCode = '';
        this.message = '';
        this.ruleId = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('error_code'),
        __metadata("design:type", Object)
    ], GraphQLAlert.prototype, "errorCode", void 0);
    __decorate([
        JsonProperty('message'),
        __metadata("design:type", Object)
    ], GraphQLAlert.prototype, "message", void 0);
    __decorate([
        JsonProperty('details', Any, true),
        __metadata("design:type", Object)
    ], GraphQLAlert.prototype, "ruleId", void 0);
    GraphQLAlert = __decorate([
        JsonObject('GraphQLAlert'),
        __metadata("design:paramtypes", [Object])
    ], GraphQLAlert);
    return GraphQLAlert;
}());
export { GraphQLAlert };
var CustomResolver = (function () {
    function CustomResolver(partial) {
        this.id = undefined;
        this.functionId = '';
        this.onType = '';
        this.fieldName = '';
        this.inputType = undefined;
        this.inputTypeFormat = undefined;
        this.payloadType = undefined;
        this.payloadTypeFormat = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('_id', String, true),
        __metadata("design:type", String)
    ], CustomResolver.prototype, "id", void 0);
    __decorate([
        JsonProperty('function_id'),
        __metadata("design:type", Object)
    ], CustomResolver.prototype, "functionId", void 0);
    __decorate([
        JsonProperty('on_type'),
        __metadata("design:type", Object)
    ], CustomResolver.prototype, "onType", void 0);
    __decorate([
        JsonProperty('field_name'),
        __metadata("design:type", Object)
    ], CustomResolver.prototype, "fieldName", void 0);
    __decorate([
        JsonProperty('input_type', Any, true),
        __metadata("design:type", Object)
    ], CustomResolver.prototype, "inputType", void 0);
    __decorate([
        JsonProperty('input_type_format', String, true),
        __metadata("design:type", String)
    ], CustomResolver.prototype, "inputTypeFormat", void 0);
    __decorate([
        JsonProperty('payload_type', Any, true),
        __metadata("design:type", Object)
    ], CustomResolver.prototype, "payloadType", void 0);
    __decorate([
        JsonProperty('payload_type_format', String, true),
        __metadata("design:type", String)
    ], CustomResolver.prototype, "payloadTypeFormat", void 0);
    CustomResolver = __decorate([
        JsonObject('CustomResolver'),
        __metadata("design:paramtypes", [Object])
    ], CustomResolver);
    return CustomResolver;
}());
export { CustomResolver };
var GraphQLAlerts = (function () {
    function GraphQLAlerts(partial) {
        this.type = GraphQLAlertType.Mongo;
        this.serviceId = '';
        this.ruleId = '';
        this.customResolverId = '';
        this.displayName = '';
        this.warnings = [];
        this.errors = [];
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('type'),
        __metadata("design:type", String)
    ], GraphQLAlerts.prototype, "type", void 0);
    __decorate([
        JsonProperty('service_id'),
        __metadata("design:type", Object)
    ], GraphQLAlerts.prototype, "serviceId", void 0);
    __decorate([
        JsonProperty('rule_id'),
        __metadata("design:type", Object)
    ], GraphQLAlerts.prototype, "ruleId", void 0);
    __decorate([
        JsonProperty('custom_resolver_id'),
        __metadata("design:type", Object)
    ], GraphQLAlerts.prototype, "customResolverId", void 0);
    __decorate([
        JsonProperty('display_name'),
        __metadata("design:type", Object)
    ], GraphQLAlerts.prototype, "displayName", void 0);
    __decorate([
        JsonProperty('warnings', [GraphQLAlert]),
        __metadata("design:type", Array)
    ], GraphQLAlerts.prototype, "warnings", void 0);
    __decorate([
        JsonProperty('errors', [GraphQLAlert]),
        __metadata("design:type", Array)
    ], GraphQLAlerts.prototype, "errors", void 0);
    GraphQLAlerts = __decorate([
        JsonObject('GraphQLAlerts'),
        __metadata("design:paramtypes", [Object])
    ], GraphQLAlerts);
    return GraphQLAlerts;
}());
export { GraphQLAlerts };
var ExtendableTypes = (function () {
    function ExtendableTypes(partial) {
        this.rootTypes = [];
        this.generatedTypes = [];
        this.generatedInputTypes = [];
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('root_types'),
        __metadata("design:type", Array)
    ], ExtendableTypes.prototype, "rootTypes", void 0);
    __decorate([
        JsonProperty('generated_types'),
        __metadata("design:type", Array)
    ], ExtendableTypes.prototype, "generatedTypes", void 0);
    __decorate([
        JsonProperty('generated_input_types'),
        __metadata("design:type", Array)
    ], ExtendableTypes.prototype, "generatedInputTypes", void 0);
    ExtendableTypes = __decorate([
        JsonObject('ExtendableTypes'),
        __metadata("design:paramtypes", [Object])
    ], ExtendableTypes);
    return ExtendableTypes;
}());
export { ExtendableTypes };
//# sourceMappingURL=GraphQL.js.map